import { useLanguage } from "@/i18n/LanguageContext";
import { Language } from "@/i18n/translations";

const LanguageToggle = () => {
  const { lang, setLang } = useLanguage();

  const toggle = () => setLang(lang === "sv" ? "en" : "sv");

  return (
    <button
      onClick={toggle}
      className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors px-2 py-1 rounded border border-border hover:border-primary/20"
      title={lang === "sv" ? "Switch to English" : "Byt till svenska"}
    >
      {lang === "sv" ? (
        <>
          <span className="text-sm">🇸🇪</span>
          <span className="tracking-wider uppercase font-medium">SV</span>
        </>
      ) : (
        <>
          <span className="text-sm">🇬🇧</span>
          <span className="tracking-wider uppercase font-medium">EN</span>
        </>
      )}
    </button>
  );
};

export default LanguageToggle;
